'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdInsertLink = function MdInsertLink(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28.4 11.6q3.4 0 5.8 2.5t2.4 5.9-2.4 5.9-5.8 2.5h-6.8v-3.2h6.8q2.1 0 3.6-1.6t1.5-3.6-1.5-3.6-3.6-1.6h-6.8v-3.2h6.8z m-15 10v-3.2h13.2v3.2h-13.2z m-6.9-1.6q0 2.1 1.5 3.6t3.6 1.6h6.8v3.2h-6.8q-3.4 0-5.8-2.5t-2.4-5.9 2.4-5.9 5.8-2.5h6.8v3.2h-6.8q-2.1 0-3.6 1.6t-1.5 3.6z' })
        )
    );
};

exports.default = MdInsertLink;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/insert-link.js
// module id = 1633
// module chunks = 168707334958949